export const FullModelToggledOffIcon = ({
  className,
  color = '#1E1E1E',
}: {
  className?: string
  color?: string
}) => {
  return (
    <svg
      width="19"
      height="22"
      viewBox="0 0 19 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M1 14.4625V4.8001C1 4.32945 1.24128 3.89605 1.62978 3.66887L5.06445 1.66043C5.43818 1.44189 5.89247 1.44692 6.26182 1.6737L9.73854 3.80838C10.1077 4.03504 10.3381 4.45014 10.346 4.90259L10.4216 9.26818C10.4298 9.73661 10.6763 10.1637 11.0659 10.3841L14.3555 12.2456C14.7522 12.4701 15 12.9083 15 13.3853V17.1914C15 17.662 14.7587 18.0954 14.3702 18.3226L10.9209 20.3396C10.5551 20.5535 10.1115 20.5535 9.74572 20.3396L1.62978 15.5937C1.24128 15.3666 1 14.9332 1 14.4625Z"
        fill="white"
      />
      <path
        d="M0 14.5835V4.58328C0.000109423 3.8528 0.38055 3.1801 0.993125 2.82747L4.60437 0.749223C5.1938 0.409967 5.91062 0.417417 6.49312 0.769457L10.1487 2.9789C10.7308 3.33078 11.0938 3.97503 11.1062 4.67727L11.1862 9.19537C11.1905 9.43776 11.3202 9.65894 11.525 9.77302L14.9837 11.6992C15.6093 12.0477 16 12.7282 16 13.4687V17.4078C15.9999 18.1383 15.6195 18.811 15.0069 19.1636L11.38 21.251C10.8032 21.583 10.1037 21.583 9.52687 21.251L0.993125 16.3393C0.380543 15.9867 5.57648e-05 15.314 0 14.5835ZM1.28 14.5835C1.28006 14.827 1.40706 15.0515 1.61125 15.169L10.1444 20.0801C10.3367 20.1908 10.5702 20.1908 10.7625 20.0801L14.3888 17.9927C14.5929 17.8752 14.7199 17.6513 14.72 17.4078V13.4687C14.72 13.2219 14.5898 12.9948 14.3812 12.8786L10.9225 10.9525C10.3081 10.6102 9.91912 9.94728 9.90625 9.22017L9.82687 4.70207C9.82275 4.46795 9.70157 4.2528 9.5075 4.13551L5.85187 1.92672C5.65775 1.8094 5.41895 1.80653 5.2225 1.91954L1.61125 3.99844C1.4071 4.11595 1.28011 4.33985 1.28 4.58328V14.5835Z"
        fill={color}
      />
      <path
        d="M10.5 4.5L5.1947 7.5L4.5 6.30548L9.5 3.5L10.5 4.5Z"
        fill={color}
      />
      <path
        d="M4.67497 11.5911V7.24717L0 4.58474L0.685983 3.5L5.36095 6.16243C5.76228 6.39109 6.00788 6.80287 6.00788 7.24717V11.5911L10.3529 14.0657C10.7612 14.2983 11.0079 14.7201 10.9998 15.1721L10.9035 20.5L9.57122 20.4778L9.66689 15.1504L5.3219 12.6758C4.92057 12.4471 4.67497 12.0354 4.67497 11.5911Z"
        fill={color}
      />
      <path
        d="M15 13.853L10.5666 16.5L10 15.147L14.4334 12.5L15 13.853Z"
        fill={color}
      />
      <path
        d="M11 9.71076L5.74487 12.5L5 11.2892L10.2551 8.5L11 9.71076Z"
        fill={color}
      />
    </svg>
  )
}
